import { render } from "./BusIcon.vue?vue&type=template&id=33c75e01&lang=pug"
const script = {}
script.render = render

export default script